import { Injectable } from '@angular/core';
import { UserSuppliersData } from '../models/auth/usersuppliersdata';

@Injectable({
    providedIn: 'root',
})
export class StorageSettings {
    // Private Keys
    public _access_token = 'access_token';
    public _user_email = 'ssEmail';
    public _user_username = 'ssUsername';
    public _user_displayname = 'ssDisplayname';
    public _user_supplierCode = 'ssUserSupplierCode';
    public _user_typeid = 'ssUserTypeid';
    public _user_CSRFToken = 'ssCSRFToken';
    public _user_SupplierName = 'ssUserSupplierName';
    public _user_SupplierSiteCode = 'ssUserSupplierSiteCode';
    public _user_SubcontractSuppliersLookup =
        'ssUserSubcontractSuppliersLookup';
    public _user_IsSupplierEdiEnabled = 'IsSupplierEdiEnabled';
    public _user_Suppliers = 'Suppliers';
    private _user_SuppliersData = 'SuppliersData';
    private _user_isPlanner = 'IsPlanner';

    // Settings Api
    public UserID: string;
    public UserName: string;
    public UserEmail: string;
    public UserDisplayName: string;
    public AccessToken: string;
    public UserTypeId: number;
    public UserSupplierCode: string;
    public CSRFToken: string;
    public UserSupplierName: string;
    public UserSupplierSiteCode: string;
    public UserSubcontractSuppliersLookup: string;
    public IsSupplierEdiEnabled: string;
    public SuppliersData: UserSuppliersData[];
    public IsPlanner: boolean;
    public CurrentPageWrite: boolean;
    public CurrentPageRead: boolean;

    // Constructor
    constructor() {
        this.reloadSettings();
    }

    // Used for reloading the settings in case any has changed.
    public reloadSettings() {
        this.UserID = this.retrieve('UserId');
        this.AccessToken = this.retrieve(this._access_token);
        this.UserName = this.retrieve(this._user_username);
        this.UserDisplayName = this.retrieve(this._user_displayname);
        this.UserEmail = this.retrieve(this._user_email);
        this.UserTypeId = this.retrieve(this._user_typeid);
        this.UserSupplierCode = this.retrieve(this._user_supplierCode);
        this.CSRFToken = this.retrieve(this._user_CSRFToken);
        this.UserSupplierName = this.retrieve(this._user_SupplierName);
        this.UserSupplierSiteCode = this.retrieve(this._user_SupplierSiteCode);
        this.UserSubcontractSuppliersLookup = this.retrieve(
            this._user_SubcontractSuppliersLookup
        );
        this.IsSupplierEdiEnabled = this.retrieve(
            this._user_IsSupplierEdiEnabled
        );
        this.SuppliersData = this.retrieve(this._user_SuppliersData);
        this.IsPlanner = this.retrieve(this._user_isPlanner);
    }

    // Retrieve storage setting.
    public retrieve(key: string): any {
        const item = localStorage.getItem(key);
        if (item && item !== 'undefined') {
            return JSON.parse(localStorage.getItem(key));
        }

        return;
    }

    // sets a value
    public store(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
        this.reloadSettings();
    }

    public getXsrfCookie(): string {
        const cookies = document.cookie.split(';');
        for (let idx = 0; idx < cookies.length; idx++) {
            const matches = cookies[idx].match(
                /\b__RequestVerificationToken_.*=([^\s;]+)/
            );
            if (matches) {
                try {
                    return decodeURIComponent(matches[1]);
                } catch (decodeError) {
                    return '';
                }
            }
        }

        return '';
    }
}
